import request from 'tools/request'
import Auth from 'tools/AuthService'

export const getHubSpotConfigForClient = () => {
    const res = request('hubspot/config', 'GET', null, true, { 'x-client-Id': Auth.selectedClient }, null, false)
    return res
}

export const createHubSpotConfigForClient = (payLoad) => {
    const res = request('hubspot/config', 'POST', payLoad, true, { 'x-client-Id': Auth.selectedClient }, null, false)
    return res
}

export const deleteHubSpotConfigForClient = (id) => {
    const res = request(`hubspot/config/${id}`, 'DELETE', null, true, { 'x-client-Id': Auth.selectedClient }, null, false)
    return res
}

export const updateAutoCreateApplicationEnabled = (enabled) => {
    const res = request(`hubspot/config/auto-create-application?enabled=${enabled}`, 'PATCH', null, true, { 'x-client-Id': Auth.selectedClient }, null, false)
    return res
}

export const updateSyncDocumentsEnabled = (enabled) => {
    const res = request(`hubspot/config/sync-documents?enabled=${enabled}`, 'PATCH', null, true, { 'x-client-Id': Auth.selectedClient }, null, false)
    return res
}

export const updateNoteEmailsEnabled = (enabled) => {
    const res = request(`hubspot/config/note-emails?enabled=${enabled}`, 'PATCH', null, true, { 'x-client-Id': Auth.selectedClient }, null, false, true)
    return res
}

// Who gets the HubSpot note email: { recipient: 'CREATOR' | 'COMPANY' | 'USERS', companyEmail, users: [email] }.
export const updateNoteEmailRecipients = (data) => {
    const res = request('hubspot/config/note-email-recipients', 'PUT', data, true, { 'x-client-Id': Auth.selectedClient }, null, false, true)
    return res
}

// Active users of the client who can be chosen to get the HubSpot note email: [{ name, email }].
export const getNoteEmailUsers = () => {
    const res = request('hubspot/config/note-email-users', 'GET', null, true, { 'x-client-Id': Auth.selectedClient }, null, false, true)
    return res
}

export const updateAutoCreateHubSpotDealsEnabled = (enabled) => {
    const res = request(`hubspot/config/auto-create-hubspot-deals?enabled=${enabled}`, 'PATCH', null, true, { 'x-client-Id': Auth.selectedClient }, null, false)
    return res
}

export const updateDestinationEntityType = (entityType) => {
    const res = request(`hubspot/config/destination-entity-type?entityType=${entityType}`, 'PATCH', null, true, { 'x-client-Id': Auth.selectedClient }, null, false)
    return res
}

export const updateMaxDocumentSyncSizeMb = (maxSizeMb) => {
    const res = request(`hubspot/config/max-document-sync-size?maxSizeMb=${maxSizeMb}`, 'PATCH', null, true, { 'x-client-Id': Auth.selectedClient }, null, false)
    return res
}

export const getSyncedDocuments = (pageLimit = 20, pageNumber = 0, sort = 'createdAt,desc', integrationType, status) => {
    const params = new URLSearchParams()
    if (integrationType) params.append('integrationType', integrationType)
    if (status) params.append('status', status)
    const query = params.toString() ? `?${params.toString()}` : ''
    return request(`integrations/synced-documents${query}`, 'GET', null, true, {
        'x-client-Id': Auth.selectedClient,
        'X-Pagination-Limit': String(pageLimit),
        'X-Pagination-Num': String(pageNumber),
        'X-Pagination-Sort': sort
    }, null, false)
}

export const retrySyncedDocument = (syncedDocumentId) => {
    return request(`integrations/synced-documents/${syncedDocumentId}/retry`, 'POST', null, true, {
        'x-client-Id': Auth.selectedClient
    }, null, false)
}

export const getHubSpotSyncExecutions = (pageLimit = 20, pageNumber = 0, sort = 'startedAt,desc') => {
    return request('hubspot/sync/executions', 'GET', null, true, {
        'x-client-Id': Auth.selectedClient,
        'X-Pagination-Limit': String(pageLimit),
        'X-Pagination-Num': String(pageNumber),
        'X-Pagination-Sort': sort
    }, null, false)
}

// Kick off a background full-sync preview (returns immediately with a RUNNING job).
export const startHubSpotPreview = () => {
    return request('hubspot/sync/preview', 'POST', null, true, {
        'x-client-Id': Auth.selectedClient
    }, null, false)
}

// Poll the current preview job status/result.
export const getHubSpotPreview = () => {
    return request('hubspot/sync/preview', 'GET', null, true, {
        'x-client-Id': Auth.selectedClient
    }, null, false)
}
